module.exports = __webpack_public_path__ + "static/media/chatpatajeeraaloo.ccf8db55.jpg";